import HomePageHero from './HomePageHero';

export default HomePageHero;
